export function KeypointIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='33' height='32' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='16.5' cy='16' r='2.5' stroke='currentColor' />
      <circle cx='16.4987' cy='15.9997' r='10.1667' stroke='currentColor' />
      <line x1='16.332' y1='1.33301' x2='16.332' y2='5.33301' stroke='currentColor' />
      <line x1='16.332' y1='26.667' x2='16.332' y2='30.667' stroke='currentColor' />
      <line x1='31.168' y1='16.5' x2='26.5013' y2='16.5' stroke='currentColor' />
      <line x1='6.5' y1='16.5' x2='1.83333' y2='16.5' stroke='currentColor' />
    </svg>
  )
}
